// extracted by mini-css-extract-plugin
export var tooltip = "Tooltip-module--tooltip--2CbFm";
export var text = "Tooltip-module--text--2MEt1";